import { Link } from 'react-router-dom';
import React, { useContext } from 'react';

import GlobalContext from 'GlobalContext';

import './NavButton.scss';

const NavButton = ({ buttonText, toLocation }) => {
  const { darkMode } = useContext(GlobalContext);

  return (
    <Link
      to={toLocation}
      className={darkMode ? 'nav-button-dark' : 'nav-button'}
    >
      {buttonText}
    </Link>
  );
};

export default NavButton;
